import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';
import type { AxiosResponse } from 'axios';
import type { SaversUser } from '../../types';

export interface userListParams {
  userType: string;
  companyId?: number;
}

export const getallUsersList = (params: userListParams) => {
  return axiosInstance.request({
    url: `${API.SAVERS}/GetAllSaversUserType`,
    method: 'get',
    params,
  });
};

export type SaversUserResponse = SaversUser[];

export const fetchAllUsersList = async (params: userListParams): Promise<SaversUserResponse> => {
  const response: AxiosResponse<SaversUserResponse> = await getallUsersList(params);
  return response.data;
};
